import { useState } from "react";
import { SectionCard } from "../components/SectionCard";
import { useAuth } from "../context/AuthContext";
import { useSetTrail } from "../context/BreadcrumbContext";
import { notify } from "../lib/api";

export function ProfilePage() {
  const { user, updatePseudo } = useAuth();
  const [pseudo, setPseudo] = useState(user?.pseudo ?? "");
  const [submitting, setSubmitting] = useState(false);

  useSetTrail([]);

  return (
    <div className="space-y-6">
      <SectionCard title="Mon profil">
        <form
          className="space-y-5"
          onSubmit={(event) => {
            event.preventDefault();
            setSubmitting(true);
            void updatePseudo(pseudo)
              .then(() => notify("success", "Pseudo mis à jour"))
              .catch(() => {})
              .finally(() => setSubmitting(false));
          }}
        >
          <div>
            <label className="label" htmlFor="profile-email">
              Email
            </label>
            <input
              id="profile-email"
              type="email"
              className="text-field opacity-60"
              disabled
              value={user?.email ?? ""}
            />
          </div>
          <div>
            <label className="label" htmlFor="profile-pseudo">
              Pseudo
            </label>
            <input
              id="profile-pseudo"
              type="text"
              className="text-field"
              placeholder="PatriceOuinOuin"
              value={pseudo}
              onChange={(event) => setPseudo(event.target.value)}
            />
          </div>
          <div className="flex justify-end">
            <button type="submit" className="btn-primary" disabled={submitting}>
              {submitting ? "Enregistrement..." : "Enregistrer"}
            </button>
          </div>
        </form>
      </SectionCard>
    </div>
  );
}
